import {sendLog} from "../common/SendLog";

//Подтверждение кода и запуск подписания
export const signFile = async (serverApi, navigate, title, confirmationCode) => {
    const docSessionCode = localStorage.getItem("doc_session_code");
    const appDebag = localStorage.getItem("app_debag");

    //Подтверждение кода и запуск подписания.
    serverApi.getCode(docSessionCode, confirmationCode, appDebag).then((response) => {
        if (response.status === 200 && response.data?.success) {
            sendLog(serverApi, title, 'Подтверждение кода и запуск подписания.', 'getCode', false, response);
            navigate('/signed');
        } else {
            sendLog(serverApi, title, 'Неверный код подтверждения или невозможно подписать.', 'getCode', true, response);
            navigate('/doc', { state: { errorCode: 'wrong_code' } });
        }
    }).catch((error) => {
        sendLog(serverApi, title, 'Сетевая ошибка getCode.', 'getCode', true, error);
        navigate('/doc', { state: { errorCode: 'network_error' } });
    });
};
